import * as constants from './constants';

import statisticalApi from '@/api/statistical';


//抄表成功率
const successRateState = (data) => {
    return {
        type: constants.SUCCESS_RATE,
        data
    };
};


// 获取抄表成功率列表数据
export const getSuccessRateList = (data) => {
    return (dispatch) => {
        statisticalApi.getSuccessRateList(data)
            .then(res => {
                dispatch(successRateState(res));
            })
    };
};


//抄表成功率
const breakRanksState = (data) => {
    return {
        type: constants.BREAK_RANKS,
        data
    };
};

// 获取抄表成功率列表数据
export const getBreakRanksList = (data) => {
    return (dispatch) => {
        statisticalApi.getBreakRanksList(data)
            .then(res => {
                dispatch(breakRanksState(res));
            })
    };
};

//通讯质量
const communicationQualityState = (data) => {
    return {
        type: constants.COMMUNICATION_QUALITY,
        data
    };
};

// 获取通讯质量列表数据
export const getCommunicationQualityList = (data) => {
    return (dispatch) => {
        statisticalApi.getCommunicationQualityList(data)
            .then(res => {
                dispatch(communicationQualityState(res));
            })
    };
};


// 获取设备异常 通过采集点 列表数据
export const getNormalsOfPointList = (data) => {
    return (dispatch) => {
        // data.category = 1;  //设备类型 1网关 2电表
        statisticalApi.getNormalsOfPointList(data)
            .then(res => {
                const _data = res || {};
                dispatch({
                    type: data.category === 1 ? constants.GATEWAY_NORMALS : constants.EQUIPMENT_NORMALS,
                    data: _data
                });
            })
    };
};


// 获取设备异常 通过网关or设备 列表
export const getNormalsOfGatewayOrDeviceList = (data) => {
    return (dispatch) => {
        // data.category = 1;  //设备类型 1网关 2电表
        statisticalApi.getNormalsOfGatewayOrDeviceList(data)
            .then(res => {
                const _data = res || {};
                dispatch({
                    type: constants.DEVICE_NORMALS,
                    data: _data
                });
            })
    };
};


